<script setup>
import AuthFormLayout from '@/components/auth/authFormLayout.vue';
import partnrUpLogo from '@/assets/logo/PartnrUP_Full.svg';
import { useAuthStore } from '@/stores/auth.store.js';
import { useMutation } from '@tanstack/vue-query';

const inviteData = computed(() => useAuthStore().inviteData);

</script>

<template>
  <!--  <AuthFormLayout :height="791">-->
  <AuthFormLayout :inviteData="inviteData">
    <div class="tw-h-full tw-w-full tw-p-4">
      <div>
        <img class="tw-mx-auto tw-w-[142px]" :src="partnrUpLogo" alt="PartnrUp" />
        <router-view v-slot="{ Component }">
          <transition name="fade" mode="out-in">
            <component :is="Component" />
          </transition>
        </router-view>
      </div>
    </div>
  </AuthFormLayout>
</template>

<style scoped></style>
